import { NO_AUTH_ERROR, USER_NOT_REGISTERED } from "../libs/api/error_codes";

const state = {
  user: null,
  user_in_project: false,
  user_auth: false,
  user_auth_login: null,
  show_reg: false,
  show_after_reg_popup: false,
  state_popup: false,
  wrong_device: false,
};
const mutations = {
  setUser(state, params) {
    state.user = params.user;
    state.user_in_project = true;
    state.user_auth = true;
  },
  setUserAuthedNotRegistered(state) {
    state.user = false;
    state.user_auth = true;
    state.user_in_project = false;
  },
  setUnAuthed(state) {
    state.user = false;
    state.user_in_project = false;
    state.user_auth = false;
  },
  setWrongDevice(state, data) {
    state.wrong_device = data;
  },
  showReg(state) {
    state.show_reg = true;
  },
  hideReg(state) {
    state.show_reg = false;
  },
  showAfterRegPopup(state) {
    state.show_after_reg_popup = true;
  },
  hideAfterRegPopup(state) {
    state.show_after_reg_popup = false;
  },
  openPopup(state) {
    state.state_popup = true;
  },
  closePopup(state) {
    state.state_popup = false;
  },
};
const actions = {
  /**
   * Try to auth user and load all user fields.
   * Can be used for user info updating.
   * @param dispatch
   * @param {object} params
   * @param {array} params.profile_fields You can provide custom profile_fields list.
   * If profile_fields doesn't provide, it will be loaded from project config.
   * @param {boolean} params.update If true, this actions won't trigger "auth_done" event.
   * @param {string} params.register_redirect_host Conatins base host for redirect_uri and destination params on VKPlay projects after registration. If null then do nothing.
   * @return {PromiseLike<unknown>}
   */
  auth({ dispatch }, params = {}) {
    let {
      profile_fields = null,
      update = false,
      method = "run",
      register_redirect_host = null,
    } = params;
    if (!profile_fields) {
      profile_fields = window.authService.getConfig().profile_fields;
    }
    return window.api.userService
      .getUserData(profile_fields)
      [method]()
      .then(response => {
        if (window.api.isApiResponseError(response)) {
          const response_error = window.api.getApiResponseError(response);
          if (register_redirect_host && response_error.code === NO_AUTH_ERROR) {
            return dispatch("gcRedirect", register_redirect_host);
          }
          return dispatch("_prepareUnregUser", response_error);
        } else {
          return dispatch("_prepareRegUser", response.data.result);
        }
      })
      .then(() => {
        window.authService.logVisit();
        if (!update) {
          document.dispatchEvent(new Event("auth_done"));
        }
      });
  },
  _prepareUnregUser({ commit }, response) {
    localStorage.removeItem(window.authService.getConfig().user.profile_storage_key);
    if (response.code === USER_NOT_REGISTERED) {
      commit("setUserAuthedNotRegistered", response.message);
      window.authService.setUserEmail(response.message);
      window.authService.showProjectReg();
    }
    if (response.code === NO_AUTH_ERROR) {
      commit("setUnAuthed");
    }
  },
  _prepareRegUser({ commit }, api_user) {
    window.authService.setUser(api_user);

    const user = Object.assign({}, window.authService.getUser());
    commit("setUser", {
      user,
    });
    if (user.newbie) {
      commit("showAfterRegPopup");
    }
  },
  gcRedirect(context, host = null) {
    window.location.href = window.authService.getJsApi().getGcRedirectUrl(host);
  },
};
const getters = {
  isUserNotAuthed(state) {
    return !state.user_auth;
  },
  isUserInProject(state) {
    return state.user_in_project && !!state.user;
  },
  isUserAuthedNotRegistered(state) {
    return state.user_auth && !state.user_in_project;
  },
  isRegShow(state) {
    return !state.isUserInProject && state.show_reg;
  },
  isSteamUser(state, getters) {
    if (!getters.isUserInProject) {
      return false;
    }
    return state.user.login.slice(-6) === "@steam";
  },
  isPSUser(state, getters) {
    if (!getters.isUserInProject) {
      return false;
    }
    return state.user.login.slice(-3) === "@ps";
  },
  isXboxUser(state, getters) {
    if (!getters.isUserInProject) {
      return false;
    }
    return state.user.login.slice(-5) === "@xbox";
  },
  isUserProcessed(state) {
    return state.user !== null;
  },
  isWrongDevice(state) {
    return state.wrong_device;
  },
  getUserPlatform(state, getters) {
    if (!getters.isUserInProject) {
      return false;
    }
    return state.user.login.split("@")[1];
  },
  getUserTechnicalNickname(state, getters) {
    if (!getters.isUserInProject) {
      return "";
    }
    return `u_${state.user.user_id}`;
  },
};
const store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
export default store;
